module.exports = __webpack_public_path__ + "media/images/logo-email-cb4e3a1a9a8fc434f890c142ca2f00a7.png";